import { useMemo } from 'react'
import {
  selectContactLocations,
  selectServiceLocations,
  selectServiceLocationsDetails,
} from '@user/store/map'
import { isPestPacMember } from '@user/store/map/typings'
import { withRefreshedPestPacKnockStatus } from '@user/store/map/pestPacPin'
import { useAppSelector } from '@user/store/hooks'

function useData() {
  const { status, locations } = useAppSelector(selectServiceLocationsDetails)
  const selectedMembers = useAppSelector(selectServiceLocations)
  const contactLocations = useAppSelector(selectContactLocations)

  const selectedServiceLocations = useMemo(
    () =>
      selectedMembers.length === 0
        ? selectedMembers
        : withRefreshedPestPacKnockStatus(selectedMembers, contactLocations),
    [selectedMembers, contactLocations],
  )

  const pestPacMembers = useMemo(
    () => selectedServiceLocations.filter(isPestPacMember),
    [selectedServiceLocations],
  )

  const salesCenterMemberCount =
    selectedServiceLocations.length - pestPacMembers.length

  return {
    loading:
      salesCenterMemberCount > 0 &&
      status !== 'success' &&
      locations.length === 0,
    locations,
    selectedServiceLocations,
    pestPacMembers,
  }
}

export default useData
